import { createConsumer } from '@rails/actioncable'

let consumer = null

function buildUrl(token) {
  const base = import.meta.env.VITE_WS_BASE
    || `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}`
  return `${base}/cable?token=${encodeURIComponent(token)}`
}

export function connectCable(token) {
  if (consumer) return consumer
  consumer = createConsumer(buildUrl(token))
  return consumer
}

export function disconnectCable() {
  if (!consumer) return
  consumer.disconnect()
  consumer = null
}
